<div
  (click)="goToApplication(application)"
  class="grid-item-container relative flex justify-center items-center"
>
  <span
    class="application-icon px-4 py-2 rounded-md w-16 h-16 text-center items-center content-center mt-1"
    [class]="
      showColor() && application?.color && !application?.disabled
        ? application?.color
        : 'bg-surface-tertiary text-color'
    "
  >
    @if (application?.icon !== '') {
      <soft-icon
        [name]="application?.icon"
        class="text-3xl"
        [class]="application?.disabled ? 'text-lighter' : ''"
      ></soft-icon>
    } @else {
      <i class="fa-regular fa-ban fa-3x"></i>
    }
  </span>
  <div class="flex flex-row w-full justify-center set-width">
    <span
      class="application-title self-baseline"
      [class]="application?.disabled ? 'text-lighter' : ''"
      >{{ application?.name | translate }}</span
    >
  </div>
  @if (showMetadata()) {
    <div class="flex w-full justify-center !text-[0.55rem]">
      @if (application?.permission) {
        <soft-icon name="fa-regular fa-lock" class="mr-1"></soft-icon>
        {{ application?.permission }}
      } @else {
        <soft-icon name="fa-regular fa-lock-open" class="mr-1 text-danger"></soft-icon>
        <p class="text-danger">Keine Vergeben</p>
      }
    </div>
  }
  @if (application?.type === 'link') {
    <div class="absolute top-2 right-2.5">
      <soft-icon
        name="fa-regular fa-arrow-up-right-from-square"
        class="text-sm opacity-50"
      ></soft-icon>
    </div>
  }
</div>
